// ============================================================================
// textosSemDado: TODOS os textos novos do "sem dado" num lugar só (A3 do
// "Dashboard sem zero silencioso", 23/10/2026). Sem travessão e sem emoji
// (um teste varre este arquivo). Nomes das unidades: AVEC_UNITS.feelKingName,
// sempre na ordem de getConfiguredUnits().
// ============================================================================
import { AVEC_UNITS, getConfiguredUnits } from '../data/avecUnitsMap.js';

export const SEM_DADO = 'Sem dado';
export const SEM_COMPARACAO = 'Sem comparação';
export const TENTAR_DE_NOVO = 'Tentar de novo';
export const BUSCANDO_DE_NOVO = 'Buscando de novo…';
export const AVISO_EQUIPE = 'Alguns números do período não carregaram.';
export const AVISO_PERIODO_SEM_DADO = 'Os números do período não vieram do Avec.';
export const AVISO_ANTERIOR_SEM_DADO = 'O período anterior não veio do Avec, então os cartões ficam sem comparação.';
// CADASTRO_SEED_TRAVADO (28/10/2026): o aparelho não semeia mais o cadastro; até
// o servidor responder as listas ficam vazias (sem dado = vazio + aviso).
export const CADASTRO_SEM_COFRE = 'O cadastro (unidades e profissionais) ainda não carregou do servidor. As listas ficam vazias até ele responder.';
export const DIAS_FECHADOS_SEM_COFRE = 'Os dias fechados ainda não carregaram do servidor. Nada foi mudado; tente de novo em instantes.';

export const ROTULO_CAMPO = {
  faturamento: 'faturamento',
  comissao: 'comissão',
  visitas: 'clientes atendidos',
  servicosRealizados: 'serviços',
  geracaoDemanda: 'geração de demanda',
  agendamentosPreferenciais: 'preferenciais',
  semPreferencia: 'sem preferência',
  clientesNovos: 'clientes novos',
  produtosVendidos: 'produtos',
  faturamentoProdutos: 'faturamento de produtos',
  valorPacotes: 'pacotes',
  pacotesVendidosTotal: 'pacotes',
  valorExtras: 'serviços extras',
  taxaRetorno: 'taxa de retorno',
  ticket: 'ticket médio',
  produtividade: 'produtividade',
};

const ordemUnidades = () => getConfiguredUnits().map(u => u.key);
export const nomeUnidade = (k) => AVEC_UNITS[k]?.feelKingName || String(k);

export function listaPt(itens) {
  const xs = (itens || []).filter(Boolean);
  if (xs.length <= 1) return xs.join('');
  return `${xs.slice(0, -1).join(', ')} e ${xs[xs.length - 1]}`;
}

export function ordenarUnidades(keys) {
  const ordem = ordemUnidades();
  return [...new Set(keys || [])].sort((a, b) => {
    const ia = ordem.indexOf(a), ib = ordem.indexOf(b);
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  });
}

/** 'Faltou Moema', 'Faltou Moema e Oscar Freire', 'Faltou Moema, Oscar Freire e Jardins'. */
export function textoFaltou(unitKeys) {
  const nomes = ordenarUnidades(unitKeys).map(nomeUnidade);
  return nomes.length ? `Faltou ${listaPt(nomes)}` : null;
}

function camposPt(campos) {
  const rot = [...new Set((campos || []).map(c => ROTULO_CAMPO[c] || c))];
  return listaPt(rot);
}
function porUnidadePt(lista) {
  return listaPt(ordenarUnidades(lista.map(x => x.unitKey))
    .map(k => { const it = lista.find(x => x.unitKey === k); return `${nomeUnidade(k)} (${camposPt(it.campos)})`; }));
}

/**
 * Aviso de página (gestão). atual/anterior: [{ unitKey, campos: [chaves de ROTULO_CAMPO] }].
 * 'Alguns números não vieram do Avec: Moema (clientes atendidos e serviços) e Oscar Freire (comissão).'
 * + ' No período anterior faltou Jardins (comissão), então esses cartões ficam sem comparação.'
 */
export function avisoGestao({ atual = [], anterior = [] } = {}) {
  const partes = [];
  if (atual.length) partes.push(`Alguns números não vieram do Avec: ${porUnidadePt(atual)}.`);
  if (anterior.length) partes.push(`No período anterior faltou ${porUnidadePt(anterior)}, então esses cartões ficam sem comparação.`);
  return partes.length ? partes.join(' ') : null;
}

/**
 * 'Faltou o dia 17/09' / 'Faltaram os dias 17/09 e 18/09' / 'Faltaram os dias 01/10 a 22/10'.
 * Revisão de render (23/10/2026): 3 ou mais dias seguidos viram "de a" (a grade inteira
 * faltando listava 22 datas dentro do cartão).
 */
export function textoFaltouDia(datasISO) {
  const iso = [...new Set(datasISO || [])].sort();
  if (!iso.length) return null;
  const br = (d) => `${d.slice(8, 10)}/${d.slice(5, 7)}`;
  const diaSeguinte = (d) => { const [y, m, dd] = d.split('-').map(Number); const x = new Date(y, m - 1, dd + 1); return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`; };
  const blocos = [];
  for (const d of iso) {
    const ult = blocos[blocos.length - 1];
    if (ult && diaSeguinte(ult[ult.length - 1]) === d) ult.push(d); else blocos.push([d]);
  }
  const partes = blocos.flatMap(b => (b.length >= 3 ? [`${br(b[0])} a ${br(b[b.length - 1])}`] : b.map(br)));
  return iso.length === 1 ? `Faltou o dia ${partes[0]}` : `Faltaram os dias ${listaPt(partes)}`;
}
